<template>
	<div>
		<div class="datatable-tools">
			<form>
				<div>
					<div class="form-groups">
						<div class="form-group nomargin">
							<div class="input-group">
								<select v-model="searchperiod" @change="searchOptionsChanged">
									<option value="0">Alle perioder</option>
									<option value="1">Startet inden for 3 måneder</option>
									<option value="2">Ikke udløbet</option>
									<option value="3">Udløbet</option>
								</select>
								<span></span>
							</div>
						</div>

						<div class="form-group" v-if="this.customerIDFixed == 0">
							<div class="input-group">
								<select v-model="customerID" @change="searchOptionsChanged">
									<option value="0">Alle institutioner</option>
									<option v-for="customer in customers" :key="customer.id" v-bind:value="customer.id">{{ customer.name }}</option>
								</select>
								<span></span>
							</div>
						</div>

						<div class="form-group">
							<div class="input-group">
								<select v-model="searchstatus" @change="searchOptionsChanged">
									<option value="0">Alle status</option>
									<option value="1">Afventer</option>
									<option value="2">Godkendt</option>
									<option value="3">Afvist</option>
									<option value="4">Arkiveret</option>
								</select>
								<span></span>
							</div>
						</div>
					</div>

					<div class="buttons-group" v-if="this.customerIDFixed == 0">
						<button class="small text" @click.prevent="resetSearch">Nulstil</button>
					</div>
				</div>
			</form>
		</div>

		<table class="datatable">
			<thead v-if="!isMobile">
			<th class="sortable active" @click="sort('customername')" v-if="customerID == 0">
				Institution
			</th>
			<th class="sortable active" @click="sort('name')">
				Aftale
			</th>
			<th class="sortable" @click="sort('schedulesort')">
				Fotografering
			</th>
			<th class="sortable" @click="sort('webshopperiodsort')">
				Webshop periode
			</th>
			<th class="sortable" @click="sort('status')">
				Status
			</th>
			<th v-show="showedit">
				Rediger
			</th>
			</thead>
			<tbody v-if="!isMobile">
				<tr v-for="(agreement, index) in (sortedActivity, filteredList)" :key="index">
					<td v-if="customerID == 0" @click="gotoAgreement(agreement)">
						{{ agreement.customername }}
					</td>
					<td @click="gotoAgreement(agreement)">
						{{ agreement.name }}
					</td>
					<td @click="gotoAgreement(agreement)">
						{{ agreement.schedulestring }}
					</td>
					<td :class="{ 'faded' : agreement.expired }" @click="gotoAgreement(agreement)">
						{{ agreement.webshopperiodstring }}
						<div class="small" v-if="agreement.expired">Udløbet</div>
					</td>
					<td @click="gotoAgreement(agreement)">
						{{ getAgreementStatus(agreement) }}
					</td>
					<td v-show="showedit">
						<RouterLink :to="{ name: 'AgreementEditFromList', params: { agreementid: agreement.id, customerid: customerID }}">
							Rediger
						</RouterLink>
					</td>
				</tr>
			</tbody>
			<tbody v-else>
				<tr v-for="(agreement, index) in (sortedActivity, filteredList)" :key="index" @click="gotoAgreement(agreement)">
					<td>
						<ul class="flex-content">
							<li data-label="Institution" v-if="customerID == null">{{ agreement.customername }}</li>
							<li data-label="Navn">{{ agreement.name }}</li>
							<li data-label="Dato">{{ agreement.schedulestring }}</li>
							<li data-label="Dato">{{ agreement.webshopperiodstring }}</li>
							<li data-label="Status">{{ getAgreementStatus(agreement) }}</li>
						</ul>
					</td>
				</tr>
			</tbody>
		</table>
		<div v-if="(data && data.length > 0) && (filteredList && filteredList.length == 0) && !isComponentBusy">
			Ingen aftaler fundet
		</div>
		<div v-if="(data == null || data.length == 0) && !isComponentBusy">
			Ingen aftaler fundet
		</div>
		<transition name="fade">
			<div class="busyloader" v-if="isComponentBusy"><div><div></div><div></div><div></div><div></div></div></div>
		</transition>
	</div>
</template>

<script>
	import { types } from "@/app/types/types"

	export default {
		name: "AgreementsList",
		components:
		{
		},
		data: () => ({
			data: [],
			customers: [],
			customerID: 0,
			customerIDFixed: 0,
			searchstatus: 0,
			searchperiod: 1,
			currentSort: "schedulesort",
			currentSortDir: "asc",
			searchSelection: "",
			pageSize: 10000,
			currentPage: 1,
			showedit: false
		}),
		props: ["search", "section", "selection"],
		mounted()
		{
			this.customerID = this.$route.params.customerid

			if (this.customerID === undefined)
			{
				this.customerID = 0
			}
			else
			{
				this.customerIDFixed = this.customerID
			}

			if (this.$route.name == "Agreements")
			{
				this.showedit = true
			}

			this.loadData(this.customerID, this.searchstatus, this.searchperiod)
			this.loadCustomers()
		},
		computed:
		{
			isMobile()
			{
				return this.$mq !== "tablethori" && this.$mq !== "desktop"
			},
			sortedActivity: function ()
			{
				// TODO: Refactor til https://vuejs.org/v2/examples/grid-component.html
				var agreements = this.data
				return agreements.sort((a, b) =>
				{
					let modifier = 1
					if (this.currentSortDir === 'desc') modifier = -1
					if (a[this.currentSort] < b[this.currentSort]) return -1 * modifier
					if (a[this.currentSort] > b[this.currentSort]) return 1 * modifier
					return 0
				}).filter((row, index) =>
				{
					let start = (this.currentPage - 1) * this.pageSize
					let end = this.currentPage * this.pageSize
					if (index >= start && index < end) return true
				})
			},
			filteredList()
			{
				var agreements = this.data
				return agreements.filter((data) =>
				{
					let name = data.name.toLowerCase().match(this.search.toLowerCase())
					let notes = data.notes.toLowerCase().match(this.search.toLowerCase())
					let customer = this.customerID == null ? data.customer.name.toLowerCase().match(this.search.toLowerCase()) : null
					return name || notes || customer
				}).filter((row, index) =>
				{
					let start = (this.currentPage - 1) * this.pageSize
					let end = this.currentPage * this.pageSize
					if (index >= start && index < end) return true
				})
			}
		},
		methods:
		{
			resetSearch()
			{
				this.customerID = 0
				this.searchperiod = 1
				this.searchstatus = 0
				this.currentSort = "schedulesort"
				this.currentSortDir = "asc"

				this.loadData(this.customerID, this.searchstatus, this.searchperiod)
			},
			searchOptionsChanged()
			{
				this.loadData(this.customerID, this.searchstatus, this.searchperiod)
			},
			showGroupNameAndType(agreement)
			{
				switch (agreement.type)
				{
					case 2:
						return "Klasse: " + agreement.name
						break
					case 3:
						return "Stue: " + agreement.name
						break
					default:
						return agreement.name
				}

			},
			async loadData(customerID, searchstatus, searchperiod)
			{
				this.setComponentAsBusy()
				let searchdata = { customerID: customerID, status: searchstatus, period: searchperiod}
				await this.$store.dispatch(types.ACTION_GET_AGREEMENTS, searchdata)
					.then(response =>
					{
						this.data = response.data

						for (var agreement of this.data)
						{
							this.setAgreementDates(agreement)
						}

						this.setComponentAsIdle()
					})
					.catch(error =>
					{
						this.setAppAsIdle()
						logError("AgreementsList.loadData()", error)
						this.showErrorAlert("Der opstod en fejl. Opdater siden og prøv igen.")
					})
			},
			async loadCustomers()
			{
				this.setAppAsBusy()
				await this.$store.dispatch(types.ACTION_GET_CUSTOMERS)
					.then(response =>
					{
						if (response.data && response.data.length > 0)
						{
							this.customers = response.data
						}

						this.setAppAsIdle()
					})
					.catch(error =>
					{
						this.setAppAsIdle()
						logError("OrderList.loadCustomers()", error)
						this.showErrorAlert("Der opstod en fejl. Opdater siden og prøv igen.")
					})
			},
			setAgreementDates(agreement)
			{
				var options = { year: "numeric", month: "long", day: "numeric" }

				if (!agreement.maxscheduledate || !agreement.minscheduledate)
				{
					let date = null

					if (agreement.maxscheduledate)
					{
						date = new Date(agreement.maxscheduledate)
					}
					else if (agreement.minscheduledate)
					{
						date = new Date(agreement.minscheduledate)
					}

					agreement.schedulestring = date.toLocaleDateString("da-dk", options)
					agreement.schedulesort = date
				}
				else if (agreement.maxscheduledate && agreement.minscheduledate)
				{
					let mindate = new Date(agreement.minscheduledate)
					let maxdate = new Date(agreement.maxscheduledate)

					let dateInterval = ""
					var minmonth = mindate.toLocaleString("default", { month: "long" })
					var maxmonth = maxdate.toLocaleString("default", { month: "long" })

					if (mindate.getFullYear() == maxdate.getFullYear())
					{
						if (mindate.getMonth() == maxdate.getMonth())
						{
							if (mindate.getDay() == maxdate.getDay())
							{
								dateInterval = maxdate.getDate() + ". " + maxmonth + " " + maxdate.getFullYear()
							}
							else
							{
								dateInterval = mindate.getDate() + " - " + maxdate.getDate() + ". " + maxmonth + " " + maxdate.getFullYear()
							}
						}
						else
						{
							dateInterval = mindate.getDate() + " " + minmonth + " - " + maxdate.getDate() + " " + maxmonth + " " + maxdate.getFullYear()
						}
					}
					else
					{
						dateInterval = mindate.getDate() + " " + minmonth + " " + mindate.getFullYear() + " - " + maxdate.getDate() + " " + maxmonth + " " + maxdate.getFullYear()
					}

					agreement.schedulesort = mindate
					agreement.schedulestring = dateInterval
				}
				else
				{
					agreement.schedulesort = new Date()
					agreement.schedulestring = "Ukendt"
				}

				if (agreement.startdate || agreement.expirationdate)
				{
					let dateInterval = ""
					let mindate = agreement.startdate ? new Date(agreement.startdate) : null
					let maxdate = agreement.expirationdate ? new Date(agreement.expirationdate) : null

					var minmonth = mindate ? mindate.toLocaleString("default", { month: "long" }) : null
					var maxmonth = maxdate ? maxdate.toLocaleString("default", { month: "long" }) : null
					agreement.expired = false

					if (mindate && maxdate)
					{
						if (mindate.getFullYear() == maxdate.getFullYear())
						{
							if (mindate.getMonth() == maxdate.getMonth())
							{
								dateInterval = mindate.getDate() + " - " + maxdate.getDate() + ". " + maxmonth + " "
							}
							else
							{
								dateInterval = mindate.getDate() + " " + minmonth + " - " + maxdate.getDate() + " " + maxmonth + " "
							}
						}
						else
						{
							dateInterval = mindate.getDate() + " " + minmonth + " " + mindate.getFullYear() + " - " + maxdate.getDate() + " " + maxmonth + " "
						}
					}
					else if (agreement.startdate && !agreement.expirationdate)
					{
						let date = new Date(agreement.startdate)
						dateInterval = "Fra d. " + date.toLocaleDateString("da-dk", options)
					}
					else if (!agreement.startdate && agreement.expirationdate)
					{
						let date = new Date(agreement.expirationdate)
						dateInterval = "Til d. " + date.toLocaleDateString("da-dk", options)
					}

					if (maxdate && maxdate < new Date())
					{
						agreement.expired = true
					}

					agreement.webshopperiodsort = agreement.startdate ? agreement.startdate : agreement.expirationdate
					agreement.webshopperiodstring = dateInterval
				}
				else
				{
					agreement.webshopperiodsort = new Date()
					agreement.webshopperiodstring = ""
				}
			},
			getAgreementStatus(agreement)
			{
				switch (agreement.status)
				{
					case 1:
						return "Afventer"
					case 2:
						return "Godkendt"
					case 2:
						return "Afvist"
					default:
						return "Ukendt"
				}
			},
			gotoAgreement(agreement)
			{
				if (!this.section || this.section == "agreements")
				{
					if (this.customerID == null || this.customerID == 0)
					{
						this.$router.push({ name: "AgreementEditFromList", params: { customerid: agreement.customerid, agreementid: agreement.id } })
					}
					else
					{
						this.$router.push({ name: "AgreementEdit", params: { customerid: agreement.customerid, agreementid: agreement.id } })
					}
				}
				else if (this.section == "orders")
				{
					this.$emit("update", { customername: agreement.customername })
					this.$router.push({ name: "OrdersPersonGroups", params: { agreementid: agreement.id, customerid: agreement.customerid } })
				}
				else if (this.section == "customer")
				{
					this.$router.push({ name: "PersonGroups", params: { agreementid: agreement.id, customerid: this.customerID } })
				}
			},
			sort: function (s)
			{
				if (s === this.currentSort)
				{
					this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc'
				}
				this.currentSort = s
			},
			nextPage: function ()
			{
				if ((this.currentPage * this.pageSize) < this.data.length) this.currentPage++
			},
			prevPage: function ()
			{
				if (this.currentPage > 1) this.currentPage--
			}
		}
	}
</script>
